import { Box, Container, Grid } from "@mui/material";
import SystemInfoPanel from "./SystemInfoPanel";
import EntryStatusPanel from "./EntryStatusPanel";
import EntryTypeGrid from "./EntryTypeGrid";
import { useSelector } from "react-redux";

export default function HomePage() {
  const auth = useSelector((state) => state.auth);

  return (
    <Container sx={{ pl: { xs: 0, md: "100px" } }}>
      <Grid container spacing={2}>
        <SystemInfoPanel />
        <EntryStatusPanel />
        <EntryTypeGrid />
      </Grid>
    </Container>
  );
}
